import {createSlice} from "@reduxjs/toolkit";
import {getCategories} from "../action/categoryActions";

const initialState = {
    loading: false,
    error: null,

    categoryMap: null
}

export const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategories.pending, (state) => {
                state.loading = true
                state.error = null;
            })
            .addCase(getCategories.fulfilled, (state, {payload}) => {
                state.loading = false;
                state.categoryMap = payload.map;
            })
            .addCase(getCategories.rejected, (state, {payload}) => {
                state.loading = false
                state.error = payload
            })
    }
});

export default categorySlice.reducer;
